import {
  call, put,
  takeEvery,
} from 'redux-saga/effects';

import {
  PRODUCT_GROUP_ASSOCIATIONS_URL,
  PRODUCT_GROUPS_URL,
  PRODUCTS_URL,
} from '../../config';
import getUrlFiltered from '../../utils/helper_functions/getUrlFiltered';
import { deleteContent } from './actions';
import { setLoader } from '../loader/actions';
import { fetchProductsData } from '../products/actions';
import { fetchProductGroupsData } from '../associations/actions';

const deleteDestination = (action) => {
  switch (action.payload.destination) {
    case 'associations':
      return PRODUCT_GROUP_ASSOCIATIONS_URL;
    case 'productGroups':
      return PRODUCT_GROUPS_URL;
    default:
      return PRODUCTS_URL;
  }
};

function* triggerFetch(destination) {
  switch (destination) {
    case 'productGroups':
      yield put(fetchProductsData());
      yield put(fetchProductGroupsData());
      break;
    case 'associations':
      yield put(fetchProductGroupsData());
      break;
    default:
      yield put(fetchProductsData());
  }
}

export function* deleteContentSaga(action) {
  yield put(setLoader('deleteContent', true));
  yield call(fetch, getUrlFiltered(deleteDestination(action)), {
    method: 'DELETE',
  });
  yield call(triggerFetch, action.payload.destination);
  yield put(setLoader('deleteContent', false));
}

export function* watchDeleteContentSaga() {
  yield takeEvery(String(deleteContent), deleteContentSaga);
}
